(() => {

	// Register slider show
	const sliderRegister = () => {
		
		document.querySelectorAll('.swiper-collection-tabs').forEach((elm) => {
			const countItem = elm.querySelectorAll('.popular-products__wrapper').length;

			jQuery(elm).not('.slick-initialized').slick({

				// normal options...
				infinite: true,
				centerMode: countItem > 2 ? true : false,
				dots: countItem > 2 ? true : false,
				rows: 2,
				centerPadding: countItem > 2 ? '30px' : '',
				dotsClass: countItem <= 2 ? 'hidden' : 'slick-dots',
			  
				// the magic
				responsive: [{
			  
					breakpoint: 1024,
					settings: {
					  slidesToShow: 1,
					  infinite: true
					}
			  
				  }, {
			  
					breakpoint: 600,
					settings: {
					  slidesToShow: 1,
					  dots: true
					}
			  
				  }, {
			  
					breakpoint: 300,
					settings: {
						slidesToShow: 1,
						dots: true
					  }
			  
				  }]
			});
		});
	}

	//Reset Slide show
	const resetSlider = () => {
		// Initialize Slider
		document.querySelectorAll('.swiper-collection-tabs').forEach((elm) => {
			if(elm){
				jQuery(elm).slick('setPosition'); // reset position also reset slider too.
			}
		});
	}

	const initSliders = () => {
		//Avtive Tabs
		document.querySelectorAll('.collection-list--tabs button').forEach((button) => {
			button.addEventListener('click', (e) => {

				let idCollection = e.target.dataset.collection;

				document.querySelectorAll('.collection-list--tabs button').forEach((elm) => {
					elm.classList.contains('filters__item_active') ? elm.classList.remove('filters__item_active') : '';
				})

				!e.target.classList.contains('filters__item_active') ? e.target.classList.add('filters__item_active') : '';

				document.querySelectorAll('.collection-tabs--content').forEach((tabContent) => {

					if(tabContent.getAttribute('id') == idCollection){
						!tabContent.classList.contains('show') ? tabContent.classList.add('show') : '';
						tabContent.classList.contains('hidden') ? tabContent.classList.remove('hidden') : '';
					}else{
						tabContent.classList.contains('show') ? tabContent.classList.remove('show') : '';
						!tabContent.classList.contains('hidden') ? tabContent.classList.add('hidden') : '';
					}
				});

				if(window.innerWidth <= 749){
					//Reset slider
					resetSlider();
				}

			})
		})

		// Initialize Slider
		window.addEventListener('resize', (e) => {
			if(window.innerWidth <= 749){
				//Reset slider
				sliderRegister();
				resetSlider();
			}
		})

		if(window.innerWidth <= 749){
			sliderRegister();
		}
		
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		if(window.innerWidth <= 749){
			initSliders();
			resetSlider();
		}
	});
})();